import(/* webpackMode: "eager" */ "/opt/buildhome/repo/panel/node_modules/next/dist/client/link.js")